import { PADDLE_PRICING_IDS } from './urls';

export const PRICING_PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    monthly: 99,
    annually: 84,
    priceIdMonthly: PADDLE_PRICING_IDS.starter.monthly,
    priceIdAnnually: PADDLE_PRICING_IDS.starter.annually,
  },
  {
    id: 'growth',
    name: 'Growth',
    monthly: 179,
    annually: 150,
    priceIdMonthly: PADDLE_PRICING_IDS.growth.monthly,
    priceIdAnnually: PADDLE_PRICING_IDS.growth.annually,
  },
  {
    id: 'pro',
    name: 'Pro',
    monthly: 349,
    annually: 299,
    priceIdMonthly: PADDLE_PRICING_IDS.pro.monthly,
    priceIdAnnually: PADDLE_PRICING_IDS.pro.annually,
  },
] as const;

export function openCheckout(priceId: string): void {
  const url = `/checkout?priceId=${encodeURIComponent(priceId)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function getPlanPriceId(
  planId: (typeof PRICING_PLANS)[number]['id'],
  billing: 'monthly' | 'annually' = 'monthly',
): string {
  const plan = PRICING_PLANS.find((entry) => entry.id === planId);
  if (!plan) {
    throw new Error(`Unknown plan: ${planId}`);
  }

  return billing === 'monthly' ? plan.priceIdMonthly : plan.priceIdAnnually;
}

export type CheckoutPlanSummary = {
  title: string;
  priceLabel: string;
};

export function getCheckoutPlanSummary(
  priceId: string | null,
): CheckoutPlanSummary | null {
  if (!priceId) return null;

  for (const plan of PRICING_PLANS) {
    if (plan.priceIdMonthly === priceId) {
      return {
        title: `${plan.name} Plan`,
        priceLabel: `$${plan.monthly} / monthly`,
      };
    }
    if (plan.priceIdAnnually === priceId) {
      return {
        title: `${plan.name} Plan`,
        priceLabel: `$${plan.annually} / monthly`,
      };
    }
  }

  return null;
}
